import React from 'react'
import { MdOutlineKeyboardBackspace } from "react-icons/md"
import "./GalleryNav.scss";
import { Container, Button, Modal } from 'react-bootstrap';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import shopIcon from "../images/icons/meteoyama_shop_icon_green_shadow.png"
import { BiSolidCart } from "react-icons/bi";
import "./Store.scss"
import { useState } from 'react';
import SignIn from '../SignIn.js';
import SignUp from '../SignUp.js';
import { LuHistory } from "react-icons/lu";
import PurchaseHistoryPopup from './PurchaseHistoryPopup';
import placeholderImagge from "../images/profile/mete-square-illustration.png"
import mete from "../images/logos/mete&design_long_text.png"



function MyVerticallyCenteredModal(props, onHide) {
    const styles = {
        backgroundColor: "#F0F0F0",
        borderRadius: "0px 0px 5px 5px",
        border: "2px solid black",
        borderTop: "none",
    }

    const HeadStyle = {
        backgroundColor: "#F0F0F0",
        border: "2px solid black",
       
    }
    


    // State to track the current mode (sign-in or sign-up)
    const [mode, setMode] = useState('signin');

    // Function to switch between sign-in and sign-up modes
    const handleSetMode = (mode) => {
        setMode(mode);
    };
    return (
        <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header closeButton style={HeadStyle}></Modal.Header>
            <Modal.Body style={styles}>
                <div className="d-flex justify-content-center alignos ">
                    <button className="btn btn-link" onClick={() => handleSetMode('signin')}>
                        Sign In
                    </button>
                    <span className="mx-2">|</span>
                    <button className="btn btn-link" onClick={() => handleSetMode('signup')}>
                        Sign Up
                    </button>
                </div>
                {mode === 'signin' ? (
                    <SignIn onHide={props.onHide} notifylogin={props.notifylogin} />
                ) : (
                    <SignUp onHide={props.onHide} notifylogin={props.notifylogin} />
                )}

            </Modal.Body>
        </Modal>
    );
}

function StoreNav({ user, onLogout, cartItems, handleShowCart }) {
    const History = useHistory();



    // const { currentUser } = useAuth();
    const [modalShow, setModalShow] = useState(false);
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const handleclosemodal = () => {
        setModalShow(false);
    };
    const handleShowModal = () => {
        setModalShow(true);
    };
    const handleProfileClick = () => {
        setIsPopupOpen(true); // Open the purchase history popup
    };
    const handleClosePopup = () => {
        setIsPopupOpen(false); // Close the popup
    };

    const [isMenuClicked, setMenuClicked] = useState(false);



    const handleMenuClick = () => {
        setMenuClicked(!isMenuClicked);

    };

    const menuStyles = {

        boxShadow: isMenuClicked ? '5px 5px 0px #121212' : '5px 5px 0px #121212',
        transition: 'box-shadow 0.3s ease-out',
        
    };


    const listStyle = {
        color: isMenuClicked ? '#F0F0F0' : '#121212',
        flexDirection: isMenuClicked ? 'row' : 'row',
        zIndex: 151,
        transition: 'all 0.3s ease-out'
    }
    const listCoverStyle = {
        marginTop: isMenuClicked ? '80px' : '0px',

        backgroundColor: isMenuClicked ? '#121212' : '#F0F0F0',
        boxShadow: isMenuClicked ? '5px 5px 0px 17px #121212' : 'none',
        display: isMenuClicked ? 'flex' : 'none',
        
        position: isMenuClicked ? 'absolute' : 'relative',
        zIndex: 0,
        transition: 'all 0.2s ease-out'
    }

    const linkStyle = {

        color: isMenuClicked ? '#F0F0F0' : '#121212',

    }


    return (
        <>
            <MyVerticallyCenteredModal
                show={modalShow}
                // handleShowModal={handleShowModal}
                onHide={handleclosemodal}
             
            />

            <Navbar expand="lg" className=" transparent navbarian" fixed="top"  >
                <div className='back'>

                    <Container className='nvu_store' style={menuStyles} >
                        <div className='flex-up'>
                            <MdOutlineKeyboardBackspace className='BackBtn' onClick={() => { History.goBack() }} />
                            <div className="storeup-push">
                                < Link to={"/"} style={{ textDecoration: 'none' }} className="storeup"><img style={{ maxWidth: '150px', paddingRight: '10px' }} src={mete} alt='brand logo' /><img src={shopIcon} alt="shopicon" className='shopIcon' /></Link>
                            </div>

                        </div>
                        <Navbar.Toggle aria-controls="basic-navbar-nav2" className='mete-btn' onClick={handleMenuClick} />
                        <Navbar.Collapse id="basic-navbar-nav2" style={listCoverStyle} >
                            <Nav className="linkys" style={listStyle}>

                                {user ? (
                                    <>
                                        <div className='sideW'>
                                            <div className="picky">

                                                <img
                                                    src={user.photoURL || placeholderImagge}
                                                    alt="Profile"
                                                    className="profile-picture"
                                                    onError={(e) => { e.target.onerror = null; e.target.src = placeholderImagge; }}

                                                />
                                            </div>

                                            <strong style={linkStyle}>{user.displayName}</strong></div>
                                        <div className="cartIcon" onClick={handleShowCart} style={linkStyle}>
                                            <BiSolidCart />
                                            {cartItems.length > 0 ? cartItems.length : 0 && <span className="badge">{cartItems.length}</span>}
                                        </div>
                                        <div className="history cartIcon" style={linkStyle}>
                                            <LuHistory onClick={handleProfileClick} />
                                        </div>
                                        <Button className='signBtn' onClick={onLogout}>Logout</Button>
                                    </>
                                ) : (
                                    <>

                                        <Button className='signBtn' onClick={handleShowModal}>Hit Me</Button>
                                    </>
                                )}

                                {/* <div><Link to={"/blog"}>Blog</Link></div> */}
                            </Nav>
                        </Navbar.Collapse>


                    </Container>

                </div>
                <PurchaseHistoryPopup isOpen={isPopupOpen} onClose={handleClosePopup} userId={user} />


            </Navbar>
        </>
    )
}

export default StoreNav
